module.exports = __webpack_public_path__ + "static/img/ket-renewal-pc-main-list-02@w.013b259.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-pc-main-list-02@w.jpg
// module id = 2k7K
// module chunks = 0